import { render, staticRenderFns } from "./CloseOverlayButton.vue?vue&type=template&id=7e6f695a&scoped=true&"
import script from "./CloseOverlayButton.vue?vue&type=script&lang=js&"
export * from "./CloseOverlayButton.vue?vue&type=script&lang=js&"
import style0 from "./CloseOverlayButton.vue?vue&type=style&index=0&id=7e6f695a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6f695a",
  null
  
)

export default component.exports